export const OTHERGOODS_INVENTORY_REQUEST = "OTHERGOODS_INVENTORY_REQUEST";
export const OTHERGOODS_INVENTORY_SUCCESS = "OTHERGOODS_INVENTORY_SUCCESS";
export const OTHERGOODS_INVENTORY_FAILED = "OTHERGOODS_INVENTORY_FAILED";
export const OTHERGOODS_HISTORY_REQUEST = "OTHERGOODS_HISTORY_REQUEST";
export const OTHERGOODS_HISTORY_SUCCESS = "OTHERGOODS_HISTORY_SUCCESS";
export const OTHERGOODS_HISTORY_FAILED = "OTHERGOODS_HISTORY_FAILED";
